import {
    PERSONAL_INFO_REQUEST,
    PERSONAL_INFO_ERROR,
    PERSONAL_INFO_SUCCESS,
    PERSONAL_INFO_DETAILS_REQUEST,
    PERSONAL_INFO_DETAILS_SUCCESS,
    PERSONAL_INFO_DETAILS_ERROR,
    PERSONAL_INFO_RESET_VALUE,
    GET_KYC_FROM_BACKEND,
    GET_KYC_FROM_BACKEND_SUCCESS,
    GET_KYC_FROM_BACKEND_ERROR,
    PERSONAL_INFO_REQ_VALUE,
    PERSONAL_INFO_REQUEST_SECOND,
    PERSONAL_INFO_SEND_DETAILS_SUCCESS,
    PERSONAL_INFO_SEND_DETAILS_ERROR,
    PERSONAL_INFO_SEND_DETAILS_RESET
} from "../actionType";

export const getPersonalInfoReqValue = (value: any) => ({
    type: PERSONAL_INFO_REQ_VALUE,
    payload: value
});

export const getPersonalInfoRequest = (token:any) => ({
    type: PERSONAL_INFO_REQUEST,
    payload: token
});

export const getPersonalInfoSuccess = (data: any) => ({
    type: PERSONAL_INFO_SUCCESS,
    payload: data
});

export const getPersonalInfoError = (error: any) => ({
    type: PERSONAL_INFO_ERROR,
    payload: error
});

export const getPersonalInfoDetails = () => ({
    type: PERSONAL_INFO_DETAILS_REQUEST,
});

export const getPersonalInfoDetails_Success = (data: any) => ({
    type: PERSONAL_INFO_DETAILS_SUCCESS,
    payload: data
});

export const getPersonalInfoDetails_Error = (error: any) => ({
    type: PERSONAL_INFO_DETAILS_ERROR,
    payload: error
});

export const getPersonalInfoResetValue = () => ({
    type: PERSONAL_INFO_RESET_VALUE,
});

export const getKycBacked = () => ({
    type: GET_KYC_FROM_BACKEND,
});

export const getKycBackedSuccess = (data: any) => ({
    type: GET_KYC_FROM_BACKEND_SUCCESS,
    payload: data
});
export const getKycBackedError = (error: any) => ({
    type: GET_KYC_FROM_BACKEND_ERROR,
    payload: error
});

export const getPersonalInfoReqSecondValue = (value: any) => ({
    type: PERSONAL_INFO_REQUEST_SECOND,
    payload: value
});

export const getPersonalInfoSendDetailsSuccess = (data: any) => ({
    type: PERSONAL_INFO_SEND_DETAILS_SUCCESS,
    payload: data
});

export const getPersonalInfoSendDetailsError = (error: any) => ({
    type: PERSONAL_INFO_SEND_DETAILS_ERROR,
    payload: error
});

export const getPersonalInfoSendDetailsReset = () => ({
    type: PERSONAL_INFO_SEND_DETAILS_RESET,
});